import React from "react";
import { saveAs } from "file-saver";
import { useViewer } from "../../../../app/hooks/hooks";
import html2canvas from "html2canvas";
import classes from "./ScreenShotButton.module.css";
import { ReactComponent as IconScreenShot } from "../Buttons/icons/icon-screenshot.svg";

function ScreenShotButton() {
    const viewer = useViewer();
    const screenShotHandle = () => {
        if (!viewer) return;
        // const screenShot = viewer.context.renderer.newScreenshot();

        const screenShot = viewer.context.renderer.newScreenshot();
        saveAs(screenShot, "screenshot.png");
        const downloadLink = document.createElement("a");
        var image = new Image();
        image.src = screenShot;
        //@ts-ignore
        image.style.background = image;
        image.style.top = "0";
        image.style.bottom = "0";
        image.style.right = "0";
        image.style.left = "0";
        image.style.width = "100vw";
        image.style.height = "100vh";
        image.style.position = "absolute";
        image.className = "screenShot";
        const container = viewer.container;
        container.appendChild(image);

        setTimeout(() => {
            html2canvas(document.body).then((canvas) => {
                canvas.toBlob((blob: Blob | null) => {
                    if (blob) {
                        const url = URL.createObjectURL(blob);
                        downloadLink.href = url;
                        downloadLink.download = "screenshot.png";
                        downloadLink.click();
                        URL.revokeObjectURL(url);
                        image.remove();
                    }
                }, "image/png");
            });
        }, 200);
    };
    return (
        <button className={classes.ScreenShotButton} onClick={screenShotHandle}>
            <IconScreenShot className={classes.icon} />
        </button>
    );
}

export default ScreenShotButton;
